"use client"

import { usePromotedGachabox } from "@/hooks/gachaboxes/useGachabox"
import { cn } from "@abraxas/ui/lib"
import { Button, NumberLoader } from "@abraxas/ui/ui"
import Link from "next/link"

export function PromotedGachaboxCard({ className }: { className?: string }) {
  const { data: gachabox } = usePromotedGachabox()

  if (!gachabox) {
    return null
  }

  const { totalRemaining, pendingCount } = gachabox
  const availableItems = totalRemaining - pendingCount
  const prizeType =
    gachabox.paymentMethods[0]!.tokenId === 1 ? "loomlocks" : "loomlock keys"

  return (
    <div
      className={cn(
        "gradient-border block mt-8 transition-all self-start",
        className,
      )}
    >
      <style jsx>
        {`
          @property --stop {
            syntax: "<length-percentage>";
            initial-value: 40%;
            inherits: false;
          }

          .gradient-border {
            padding: 1px;
            border-radius: 13px;
            transition: --stop 0.25s linear;
            background-image: linear-gradient(
              150deg,
              var(--color-brand-blue-800) var(--stop),
              var(--color-yellow) 100%
            );
          }

          .gradient-border:hover {
            --stop: -80%;
          }
        `}
      </style>
      <Link
        href={`/gachaboxes/${gachabox.slug}`}
        className={cn(
          "max-w-3xl",
          "relative rounded-xl",
          "flex align-center gap-6 px-10",
        )}
        style={{
          backgroundImage:
            "linear-gradient(-190deg, var(--color-brand-blue-600) 48%, var(--color-brand-blue-400) 100%)",
        }}
      >
        <div className="flex-shrink-0 mr-8 align-self-end flex items-end">
          <img
            src="https://lock.nyc3.cdn.digitaloceanspaces.com/assets/illustrations/gachabox-left.webp"
            alt="Gachabox"
            className="h-full scale-y-125 -scale-x-125 transform-origin-bottom object-contain md:w-40 md:h-40"
            style={{ transformOrigin: "bottom " }}
          />
        </div>
        <div className="flex-1 py-6 flex items-center justify-between gap-16">
          <div className="">
            <h3 className="font-semibold text-heading-s text-accent-yellow mb-1">
              Gachabox
            </h3>
            <p className="font-medium text-body-m text-white mb-4">
              Win one of {gachabox.tokens.length.toLocaleString()} {prizeType}
            </p>
            <div className="font-semibold text-body-s text-yellow px-3 py-1 rounded-md bg-brand-blue-600 uppercase inline-block">
              <NumberLoader value={availableItems} /> items left
            </div>
          </div>
          <Button color="yellow" size="large">
            Enter now
          </Button>
        </div>
      </Link>
    </div>
  )
}
